import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'regulations-kolton-en',
    templateUrl: './regulations-kolton-en.component.html',
    styleUrls: ['./regulations-kolton-en.component.scss']
})
export class RegulationsKoltonEnComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
